// default value would prevent issues with undefined
export default function capitalizeFirstLetter(string = "") {
    if (string[0] && typeof string === "string") {
        return string[0].toUpperCase() + string.slice(1);
    } else {
        return "";
    }
}
